import {RecentScan} from '../../domain/dashboard/entities/DashboardData';
import {Delivery} from '../../domain/scan/entities/Delivery';

/**
 * API response structure for delivery
 */
export interface DeliveryApiResponse {
  id: number;
  assignment_id: number;
  benefit_id: number;
  case_user_id: number;
  delivered_date: string | null; // Can be null for pending deliveries
  delivery_amount: number;
  created_by_id: number;
  created_at: string;
  benefit_description: string;
  case_data: string;
  status: number;
  status_name: string;
  notes: string | null;
}

/**
 * API response structure for deliveries list (paginated)
 */
export interface DeliveriesApiResponse {
  items: DeliveryApiResponse[];
  total: number;
}

/**
 * Maps a delivery API response to Delivery entity
 */
export function mapDeliveryResponse(response: DeliveryApiResponse): Delivery {
  return {
    id: response.id,
    assignmentId: response.assignment_id,
    benefitId: response.benefit_id,
    caseUserId: response.case_user_id,
    deliveredDate: response.delivered_date ? new Date(response.delivered_date) : new Date(response.created_at),
    deliveryAmount: response.delivery_amount,
    createdById: response.created_by_id,
    createdAt: new Date(response.created_at),
    benefitDescription: response.benefit_description,
    caseData: response.case_data,
    status: response.status,
    statusName: response.status_name,
    notes: response.notes,
  };
}

/**
 * Maps a delivery API response to RecentScan entity
 */
export function mapDeliveryToRecentScan(delivery: DeliveryApiResponse): RecentScan {
  // Map status: 1=Pending, 2=Completed, 3=Cancelled
  let status: 'success' | 'failed' | 'pending';
  if (delivery.status === 2) {
    status = 'success';
  } else if (delivery.status === 3) {
    status = 'failed';
  } else {
    status = 'pending';
  }

  return {
    id: delivery.id.toString(),
    qrCode: `DELIVERY-${delivery.id}`,
    beneficiary: {
      id: delivery.case_user_id.toString(),
      name: delivery.case_data,
      documentNumber: '',
      qrCode: '',
    },
    service: {
      id: delivery.benefit_id.toString(),
      name: delivery.benefit_description,
      description: delivery.benefit_description,
      price: 0,
      providerId: '0',
      providerName: '',
      status: 'active',
    },
    scanDate: delivery.delivered_date ? new Date(delivery.delivered_date) : new Date(delivery.created_at),
    status,
    canRedeem: false,
    caseId: delivery.case_user_id,
    benefitId: delivery.benefit_id,
    programId: 0,
    assignmentId: delivery.assignment_id,
    unitsRedeemed: delivery.delivery_amount,
    costPerUnit: 0,
    totalCost: 0,
    redemptionStatus: delivery.status_name.toUpperCase(),
    createdAt: new Date(delivery.created_at),
    notes: delivery.notes || undefined,
  };
}
